import {
  FilterTypeOption,
  ReportFilter,
  SortBy,
  SortDirection,
  SearchComponent,
  FiltersComponent,
  SortComponent,
} from '@ltvco/refresh-lib/v2';
import { Stack } from '@ltvco/refresh-lib/theme';

type SearchAndFilterControlsProps = {
  setQueryParams: any;
  onSearchChange: (searchBy: string) => void;
  reportTypeFilterOptions: { [key: string]: FilterTypeOption };
  filterTypes: ReportFilter[];
  setFilterTypes: (reportTypes: ReportFilter[]) => void;
  sort_by: SortBy;
  sort_direction: SortDirection;
};

export function SearchAndFilterControls({
  setQueryParams,
  onSearchChange,
  reportTypeFilterOptions,
  filterTypes,
  setFilterTypes,
  sort_by,
  sort_direction,
}: SearchAndFilterControlsProps) {
  return (
    <Stack direction={{ xl: 'row', xs: 'column' }} spacing={1.5}>
      <SearchComponent onSearchChange={onSearchChange} />
      <Stack direction="row" spacing={1.5}>
        <FiltersComponent
          reportTypeOptions={reportTypeFilterOptions}
          reportTypes={filterTypes}
          setReportTypes={setFilterTypes}
        />
        <SortComponent
          currentSort={{ sort_by, sort_direction }}
          setQueryParams={setQueryParams}
        />
      </Stack>
    </Stack>
  );
}
